// Registro único de páginas/menus (espelha backend/src/lib/pages.ts).
// Usado pelo menu (Layout), pelos guards de rota (App) e pelo editor de acesso (UsersPage).

export type PageKey =
  | 'dashboard'
  | 'somatoria'
  | 'events'
  | 'institute'
  | 'timeline'
  | 'manage-events'
  | 'fx-rates'
  | 'budgets'
  | 'users'
  | 'audit';

export type PageGroup = 'overview' | 'planning' | 'admin';

export interface PageMeta {
  key: PageKey;
  route: string;
  labelKey: string;     // chave i18n
  group: PageGroup;
  defaultRoles: string[]; // 'none' = sem perfil
}

export const PAGES: PageMeta[] = [
  { key: 'dashboard',     route: '/',             labelKey: 'nav_dashboard', group: 'overview', defaultRoles: ['none', 'ops', 'finance', 'admin'] },
  { key: 'somatoria',     route: '/somatoria',    labelKey: 'nav_somatoria', group: 'overview', defaultRoles: ['ops', 'finance', 'admin'] },
  { key: 'events',        route: '/events',       labelKey: 'nav_events',    group: 'planning', defaultRoles: ['ops', 'finance', 'admin'] },
  { key: 'institute',     route: '/institute',    labelKey: 'nav_institute', group: 'planning', defaultRoles: ['ops', 'finance', 'admin'] },
  { key: 'timeline',      route: '/timeline',     labelKey: 'nav_timeline',  group: 'planning', defaultRoles: ['ops', 'finance', 'admin'] },
  { key: 'manage-events', route: '/manage-events',labelKey: 'nav_manage',    group: 'admin',    defaultRoles: ['admin'] },
  { key: 'fx-rates',      route: '/fx-rates',     labelKey: 'nav_fx_rates',  group: 'admin',    defaultRoles: ['finance', 'admin'] },
  { key: 'budgets',       route: '/budgets',      labelKey: 'nav_budgets',   group: 'admin',    defaultRoles: ['admin'] },
  { key: 'users',         route: '/users',        labelKey: 'nav_users',     group: 'admin',    defaultRoles: ['admin'] },
  { key: 'audit',         route: '/audit',        labelKey: 'nav_audit',     group: 'admin',    defaultRoles: ['admin'] },
];

export const PAGE_BY_ROUTE: Record<string, PageMeta> = Object.fromEntries(PAGES.map((p) => [p.route, p]));

export function roleDefaultPages(role: string | null | undefined): PageKey[] {
  const rk = role ?? 'none';
  return PAGES.filter((p) => p.defaultRoles.includes(rk)).map((p) => p.key);
}

/** Páginas efetivas de um usuário (mesma regra do backend). admin sempre full. */
export function effectivePages(role: string | null | undefined, pageAccess: string[] | null | undefined): PageKey[] {
  const defaults = roleDefaultPages(role);
  if (role === 'admin') return defaults;
  if (!pageAccess || pageAccess.length === 0) return defaults;
  return defaults.filter((k) => pageAccess.includes(k));
}
